import React from "../../__compat__/react/main.entry.mjs.mjs";
import { useTransitionEvent } from "../../hooks/useTransitionEvent.mjs.mjs";
import { useSpacing } from "../../api/spacing/useSpacing.mjs.mjs";
import { Icon } from "../Icon/index.mjs.mjs";
import { Loader } from "../Loader/index.mjs.mjs";
import { StyledIconButton, StyledIconContainer, StyledTransitionContainer, StyledIconButtonWrapper, StyledIconButtonLabel, } from "./Button.styles.mjs.mjs";
export const IconButton = React.forwardRef((props, ref) => {
    const icon = props.icon;
    const iconElement = React.useMemo(() => {
        return typeof icon === 'string' ? (React.createElement(Icon, { size: "small", name: icon })) : (React.createElement(StyledIconContainer, null, icon));
    }, [icon]);
    const outerSpacing = useSpacing(props);
    const [loaderVisible, setLoaderVisible] = React.useState(props.isLoading);
    const handleTransitionEvent = React.useCallback((e) => {
        if (e.currentTarget) {
            const opacity = getComputedStyle(e.currentTarget).opacity;
            const isVisible = opacity !== '0';
            if (loaderVisible !== isVisible)
                setLoaderVisible(isVisible);
        }
    }, [setLoaderVisible, loaderVisible]);
    const transitionElementRef = useTransitionEvent(handleTransitionEvent);
    const iconButtonElement = React.useMemo(() => {
        return (React.createElement(StyledIconButton, { ref: ref, ...props, outerSpacing: outerSpacing },
            React.createElement(StyledTransitionContainer, { overlay: true, visible: !!props.isLoading, ref: transitionElementRef, "aria-hidden": true }, loaderVisible && (React.createElement(Loader, { monochrome: true, size: "large", inverted: props.variant === 'icon-primary' }))),
            props.icon && iconElement));
    }, [
        iconElement,
        loaderVisible,
        outerSpacing,
        props,
        ref,
        transitionElementRef,
    ]);
    return props.label ? (React.createElement(StyledIconButtonWrapper, null,
        iconButtonElement,
        React.createElement(StyledIconButtonLabel, { outerSpacing: outerSpacing, variant: "copy2" }, props.label))) : (iconButtonElement);
});
IconButton.displayName = 'IconButton';
//# sourceMappingURL=IconButton.mjs.mjs.map